import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { HomeComponent } from './components/home/home.component';
import { AppConstants } from './app.constants';
import { DashboardNoteComponent } from './components/dashboard-note/dashboard-note.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shared/components/header-layout/header-layout.component').then(
        (m) => m.HeaderLayoutComponent
      ),

    children: [
      {
        path: 'ChineseDummy',
        loadComponent: () =>
          import(
            './components/job-bag/chinese-dummy-form/chinese-dummy-form.component'
          ).then((m) => m.ChineseDummyFormComponent),
        canActivate: [authGuard],
      },
      {
        path: 'chinese-dummy-form',
        redirectTo: 'ChineseDummy',
        pathMatch: 'full',
      },
      {
        path: 'Job',
        loadComponent: () =>
          import('./components/dummy-form/dummy-form.component').then(
            (m) => m.DummyFormComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'ESubCheckListForm', // uppercase route
        loadComponent: () =>
          import('./components/e-sub-checklist/add-edit-checklist/add-edit-checklist.component').then(
            (m) => m.AddEditChecklistComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'ChecklistPreviewForm',
        loadComponent: () =>
          import('./components/e-sub-checklist/checklist-preview-form/checklist-preview-form.component').then(
            (m) => m.ChecklistPreviewFormComponent
          ),
        canActivate: [authGuard],
      },
    ],
  },

  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'Home',
        loadComponent: () =>
          import('./components/home-page/home-page.component').then(
            (m) => m.HomePageComponent
          ),
        canActivate: [authGuard],
      },

      {
        path: 'OTBooking', // uppercase route
        loadComponent: () =>
          import('./components/ot-booking/ot-booking.component').then(
            (m) => m.OTBookingComponent
          ),
            canActivate: [authGuard],
      },
      {
        path: 'OtBookingPmScheduler', // uppercase route
        loadComponent: () =>
          import('./components/ot-booking-pm-scheduler/ot-booking-pm-scheduler.component').then(
            (m) => m.OtBookingPmSchedulerComponent
          ),
      },
      {
        path: 'ot-booking', // lowercase alias
        redirectTo: 'OTBooking',
        pathMatch: 'full',
      },
      {
        path: 'Holiday',
        loadComponent: () =>
          import('./components/holiday/holiday.component').then(
            (m) => m.HolidayComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: 'OperationsReport',
        loadChildren: () =>
          import('./components/Reports/report-routes').then(
            (m) => m.reportRoutes
          ),
        canActivate: [authGuard],
      },

      {
        path: 'ESubCheckList', // uppercase route
        loadComponent: () =>
          import('./components/e-sub-checklist/e-sub-checklist.component').then(
            (m) => m.ESubChecklistComponent
          ),
           canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'jobbag',
    loadComponent: () =>
      import('./components/job-bag/job-bag.component').then(
        (m) => m.JobBagComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'workingGroup',
    loadComponent: () =>
      import('./components/job-bag/working-group/working-group.component').then(
        (m) => m.WorkingGroupComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'sectionSummary',
    loadComponent: () =>
      import(
        './components/job-bag/section-summary/section-summary.component'
      ).then((m) => m.SectionSummaryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'otBookingFiles',
    loadComponent: () =>
      import(
        './components/ot-booking/ot-booking-files/ot-booking-files.component'
      ).then((m) => m.OtBookingFilesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'email',
    loadComponent: () =>
      import('./components/associate-email/associate-email.component').then(
        (m) => m.AssociateEmailComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'milestone',
    loadComponent: () =>
      import('./components/milestone/milestone.component').then(
        (m) => m.MilestoneComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'DashboardNoteBoard',
    component: DashboardNoteComponent,
    canActivate: [authGuard],
  }
];
